export default __webpack_public_path__ + "img/gWPsEVkH.ebe29412.svg";